import { render, staticRenderFns } from "./profitQry.vue?vue&type=template&id=bcd3b0f2"
import script from "./profitQry.vue?vue&type=script&lang=js"
export * from "./profitQry.vue?vue&type=script&lang=js"
import style0 from "./profitQry.vue?vue&type=style&index=0&id=bcd3b0f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports